/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddCalendarProfile,
  GetProfilesResponse,
  UpdateCalendarProfile
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiWebCalendarCanAddPersonalCalenderUrl = () => {


  

  return `/api/web-calendar/CanAddPersonalCalender`
}

export const getApiWebCalendarCanAddPersonalCalender = async ( options?: RequestInit): Promise<boolean> => {
  
  return customInstance<boolean>(getGetApiWebCalendarCanAddPersonalCalenderUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetApiWebCalendarCanAddPersonalCalenderQueryKey = () => {
    return [
    `/api/web-calendar/CanAddPersonalCalender`
    ] as const;
    }

    
export const getGetApiWebCalendarCanAddPersonalCalenderQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarCanAddPersonalCalenderQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>> = ({ signal }) => getApiWebCalendarCanAddPersonalCalender({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWebCalendarCanAddPersonalCalenderQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>>
export type GetApiWebCalendarCanAddPersonalCalenderQueryError = ErrorType<unknown>


export function useGetApiWebCalendarCanAddPersonalCalender<TData = Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarCanAddPersonalCalender<TData = Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarCanAddPersonalCalender<TData = Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWebCalendarCanAddPersonalCalender<TData = Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWebCalendarCanAddPersonalCalenderQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetApiWebCalendarCanAddPersonalCalenderSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarCanAddPersonalCalenderQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>> = ({ signal }) => getApiWebCalendarCanAddPersonalCalender({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWebCalendarCanAddPersonalCalenderSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>>
export type GetApiWebCalendarCanAddPersonalCalenderSuspenseQueryError = ErrorType<unknown>


export function useGetApiWebCalendarCanAddPersonalCalenderSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarCanAddPersonalCalenderSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarCanAddPersonalCalenderSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWebCalendarCanAddPersonalCalenderSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarCanAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWebCalendarCanAddPersonalCalenderSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetApiWebCalendarGetProfilesUrl = () => {


  

  return `/api/web-calendar/get-profiles`
}

export const getApiWebCalendarGetProfiles = async ( options?: RequestInit): Promise<GetProfilesResponse> => {
  
  return customInstance<GetProfilesResponse>(getGetApiWebCalendarGetProfilesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetApiWebCalendarGetProfilesQueryKey = () => {
    return [
    `/api/web-calendar/get-profiles`
    ] as const;
    }

    
export const getGetApiWebCalendarGetProfilesQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarGetProfilesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>> = ({ signal }) => getApiWebCalendarGetProfiles({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWebCalendarGetProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>>
export type GetApiWebCalendarGetProfilesQueryError = ErrorType<unknown>


export function useGetApiWebCalendarGetProfiles<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarGetProfiles<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarGetProfiles<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWebCalendarGetProfiles<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWebCalendarGetProfilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetApiWebCalendarGetProfilesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarGetProfilesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>> = ({ signal }) => getApiWebCalendarGetProfiles({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWebCalendarGetProfilesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>>
export type GetApiWebCalendarGetProfilesSuspenseQueryError = ErrorType<unknown>


export function useGetApiWebCalendarGetProfilesSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarGetProfilesSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarGetProfilesSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWebCalendarGetProfilesSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWebCalendarGetProfilesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetApiWebCalendarExportIdUrl = (id: string,) => {


  

  return `/api/web-calendar/export/${id}`
}

export const getApiWebCalendarExportId = async (id: string, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getGetApiWebCalendarExportIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetApiWebCalendarExportIdQueryKey = (id?: string,) => {
    return [
    `/api/web-calendar/export/${id}`
    ] as const;
    }

    
export const getGetApiWebCalendarExportIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarExportIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarExportId>>> = ({ signal }) => getApiWebCalendarExportId(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWebCalendarExportIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarExportId>>>
export type GetApiWebCalendarExportIdQueryError = ErrorType<unknown>


export function useGetApiWebCalendarExportId<TData = Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarExportId>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarExportId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarExportId<TData = Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarExportId>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarExportId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarExportId<TData = Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWebCalendarExportId<TData = Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWebCalendarExportIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetApiWebCalendarExportIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarExportIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarExportId>>> = ({ signal }) => getApiWebCalendarExportId(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWebCalendarExportIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarExportId>>>
export type GetApiWebCalendarExportIdSuspenseQueryError = ErrorType<unknown>


export function useGetApiWebCalendarExportIdSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarExportIdSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarExportIdSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWebCalendarExportIdSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWebCalendarExportIdSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetApiWebCalendarExportIdNameUrl = (id: string,
    name: string,) => {


  

  return `/api/web-calendar/export/${id}/${name}`
}

export const getApiWebCalendarExportIdName = async (id: string,
    name: string, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getGetApiWebCalendarExportIdNameUrl(id,name),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetApiWebCalendarExportIdNameQueryKey = (id?: string,
    name?: string,) => {
    return [
    `/api/web-calendar/export/${id}/${name}`
    ] as const;
    }

    
export const getGetApiWebCalendarExportIdNameQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(id: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarExportIdNameQueryKey(id,name);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>> = ({ signal }) => getApiWebCalendarExportIdName(id,name, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id && name), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWebCalendarExportIdNameQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>>
export type GetApiWebCalendarExportIdNameQueryError = ErrorType<unknown>


export function useGetApiWebCalendarExportIdName<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarExportIdName<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarExportIdName<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWebCalendarExportIdName<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWebCalendarExportIdNameQueryOptions(id,name,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetApiWebCalendarExportIdNameSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(id: string,
    name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarExportIdNameQueryKey(id,name);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>> = ({ signal }) => getApiWebCalendarExportIdName(id,name, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWebCalendarExportIdNameSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>>
export type GetApiWebCalendarExportIdNameSuspenseQueryError = ErrorType<unknown>


export function useGetApiWebCalendarExportIdNameSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarExportIdNameSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarExportIdNameSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWebCalendarExportIdNameSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWebCalendarExportIdNameSuspenseQueryOptions(id,name,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsUrl = () => {


  

  return `/api/web-calendar/add-personal-web-calendar-profile-defaults`
}

export const getApiWebCalendarAddPersonalWebCalendarProfileDefaults = async ( options?: RequestInit): Promise<AddCalendarProfile> => {
  
  return customInstance<AddCalendarProfile>(getGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsQueryKey = () => {
    return [
    `/api/web-calendar/add-personal-web-calendar-profile-defaults`
    ] as const;
    }

    
export const getGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>> = ({ signal }) => getApiWebCalendarAddPersonalWebCalendarProfileDefaults({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWebCalendarAddPersonalWebCalendarProfileDefaultsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>>
export type GetApiWebCalendarAddPersonalWebCalendarProfileDefaultsQueryError = ErrorType<unknown>


export function useGetApiWebCalendarAddPersonalWebCalendarProfileDefaults<TData = Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarAddPersonalWebCalendarProfileDefaults<TData = Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarAddPersonalWebCalendarProfileDefaults<TData = Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWebCalendarAddPersonalWebCalendarProfileDefaults<TData = Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>> = ({ signal }) => getApiWebCalendarAddPersonalWebCalendarProfileDefaults({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWebCalendarAddPersonalWebCalendarProfileDefaultsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>>
export type GetApiWebCalendarAddPersonalWebCalendarProfileDefaultsSuspenseQueryError = ErrorType<unknown>


export function useGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarAddPersonalWebCalendarProfileDefaults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWebCalendarAddPersonalWebCalendarProfileDefaultsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPostApiWebCalendarAddPersonalWebCalendarProfileUrl = () => {


  

  return `/api/web-calendar/AddPersonalWebCalendarProfile`
}

export const postApiWebCalendarAddPersonalWebCalendarProfile = async (addCalendarProfile: AddCalendarProfile, options?: RequestInit): Promise<string> => {
  
  return customInstance<string>(getPostApiWebCalendarAddPersonalWebCalendarProfileUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addCalendarProfile,)
  }
);}




export const getPostApiWebCalendarAddPersonalWebCalendarProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebCalendarAddPersonalWebCalendarProfile>>, TError,{data: BodyType<AddCalendarProfile>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWebCalendarAddPersonalWebCalendarProfile>>, TError,{data: BodyType<AddCalendarProfile>}, TContext> => {

const mutationKey = ['postApiWebCalendarAddPersonalWebCalendarProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWebCalendarAddPersonalWebCalendarProfile>>, {data: BodyType<AddCalendarProfile>}> = (props) => {
          const {data} = props ?? {};

          return  postApiWebCalendarAddPersonalWebCalendarProfile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWebCalendarAddPersonalWebCalendarProfileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWebCalendarAddPersonalWebCalendarProfile>>>
    export type PostApiWebCalendarAddPersonalWebCalendarProfileMutationBody = BodyType<AddCalendarProfile>
    export type PostApiWebCalendarAddPersonalWebCalendarProfileMutationError = ErrorType<unknown>

    export const usePostApiWebCalendarAddPersonalWebCalendarProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebCalendarAddPersonalWebCalendarProfile>>, TError,{data: BodyType<AddCalendarProfile>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWebCalendarAddPersonalWebCalendarProfile>>,
        TError,
        {data: BodyType<AddCalendarProfile>},
        TContext
      > => {

      const mutationOptions = getPostApiWebCalendarAddPersonalWebCalendarProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getPostApiWebCalendarDeletePersonalWebCalendarProfileUrl = () => {


  

  return `/api/web-calendar/delete-personal-web-calendar-profile`
}

export const postApiWebCalendarDeletePersonalWebCalendarProfile = async (postApiWebCalendarDeletePersonalWebCalendarProfileBody: string, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getPostApiWebCalendarDeletePersonalWebCalendarProfileUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postApiWebCalendarDeletePersonalWebCalendarProfileBody,)
  }
);}




export const getPostApiWebCalendarDeletePersonalWebCalendarProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebCalendarDeletePersonalWebCalendarProfile>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWebCalendarDeletePersonalWebCalendarProfile>>, TError,{data: BodyType<string>}, TContext> => {

const mutationKey = ['postApiWebCalendarDeletePersonalWebCalendarProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWebCalendarDeletePersonalWebCalendarProfile>>, {data: BodyType<string>}> = (props) => {
          const {data} = props ?? {};

          return  postApiWebCalendarDeletePersonalWebCalendarProfile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWebCalendarDeletePersonalWebCalendarProfileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWebCalendarDeletePersonalWebCalendarProfile>>>
    export type PostApiWebCalendarDeletePersonalWebCalendarProfileMutationBody = BodyType<string>
    export type PostApiWebCalendarDeletePersonalWebCalendarProfileMutationError = ErrorType<unknown>

    export const usePostApiWebCalendarDeletePersonalWebCalendarProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebCalendarDeletePersonalWebCalendarProfile>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWebCalendarDeletePersonalWebCalendarProfile>>,
        TError,
        {data: BodyType<string>},
        TContext
      > => {

      const mutationOptions = getPostApiWebCalendarDeletePersonalWebCalendarProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getPostApiWebCalendarUpdatePersonalWebCalendarProfileUrl = () => {


  

  return `/api/web-calendar/update-personal-web-calendar-profile`
}

export const postApiWebCalendarUpdatePersonalWebCalendarProfile = async (updateCalendarProfile: UpdateCalendarProfile, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getPostApiWebCalendarUpdatePersonalWebCalendarProfileUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCalendarProfile,)
  }
);}




export const getPostApiWebCalendarUpdatePersonalWebCalendarProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebCalendarUpdatePersonalWebCalendarProfile>>, TError,{data: BodyType<UpdateCalendarProfile>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWebCalendarUpdatePersonalWebCalendarProfile>>, TError,{data: BodyType<UpdateCalendarProfile>}, TContext> => {

const mutationKey = ['postApiWebCalendarUpdatePersonalWebCalendarProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWebCalendarUpdatePersonalWebCalendarProfile>>, {data: BodyType<UpdateCalendarProfile>}> = (props) => {
          const {data} = props ?? {};

          return  postApiWebCalendarUpdatePersonalWebCalendarProfile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWebCalendarUpdatePersonalWebCalendarProfileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWebCalendarUpdatePersonalWebCalendarProfile>>>
    export type PostApiWebCalendarUpdatePersonalWebCalendarProfileMutationBody = BodyType<UpdateCalendarProfile>
    export type PostApiWebCalendarUpdatePersonalWebCalendarProfileMutationError = ErrorType<unknown>

    export const usePostApiWebCalendarUpdatePersonalWebCalendarProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebCalendarUpdatePersonalWebCalendarProfile>>, TError,{data: BodyType<UpdateCalendarProfile>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWebCalendarUpdatePersonalWebCalendarProfile>>,
        TError,
        {data: BodyType<UpdateCalendarProfile>},
        TContext
      > => {

      const mutationOptions = getPostApiWebCalendarUpdatePersonalWebCalendarProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    